import React from 'react';
import PropTypes from 'prop-types';

import SearchSuggestionListItem from '../SearchSuggestionListItem';

import './SearchSuggestionList.scss';

const SearchSuggestionList = ({
  term,
  searchSuggestions,
  selectedSuggestionIndex,
  updateSelectedSuggestionIndex,
  onSearchItemClick,
  className,
  searchsuggestionImprovement,
  isRedirectModalEnabled,
  modalRef,
  app,
}) => {
  const handleUpdateSelectedIndex = () => {
    if (selectedSuggestionIndex !== -1) {
      updateSelectedSuggestionIndex && updateSelectedSuggestionIndex(-1);
    }
  };

  if (searchsuggestionImprovement === 'EnablePopularTrue') {
    searchSuggestions.splice(1, 1);
  }

  const hasEntities = searchSuggestions && searchSuggestions.length > 0;

  const searchSuggestionList = hasEntities ? (
    <div className="SearchSuggestionList__list">
      <ul className="SearchSuggestionList__listGroup">
        {searchSuggestions.map((searchSuggestion, index) => {
          const selected = selectedSuggestionIndex === index;

          return (
            <li key={index} onMouseEnter={handleUpdateSelectedIndex}>
              <SearchSuggestionListItem
                app={app}
                searchSuggestion={searchSuggestion}
                term={term}
                index={index}
                selected={selected}
                onListItemClick={onSearchItemClick}
                isRedirectModalEnabled={isRedirectModalEnabled}
                modalRef={modalRef}
              />
            </li>
          );
        })}
      </ul>
    </div>
  ) : null;

  let suggestListClassName = 'SearchSuggestionList';

  if (className) {
    suggestListClassName += ` ${className}`;
  }

  return <div className={suggestListClassName}>{searchSuggestionList}</div>;
};

SearchSuggestionList.propTypes = {
  /**
   * Handler function to update the selected suggestion index.
   */
  updateSelectedSuggestionIndex: PropTypes.func,

  /**
   * Handler function to handle item click on search suggestion.
   */
  onSearchItemClick: PropTypes.func.isRequired,

  /**
   * Array of search suggestions to display.
   */
  searchSuggestions: PropTypes.array,

  /**
   * Current search term.
   */
  term: PropTypes.string,

  /**
   * Index of the currently selected suggestion.
   */
  selectedSuggestionIndex: PropTypes.number,

  /**
   * Optional class name for additional styling.
   */
  className: PropTypes.string,

  /**
   * Optional flag for search suggestion improvement.
   */
  searchsuggestionImprovement: PropTypes.string,

  /**
   * Flag to enable modal redirection.
   */
  isRedirectModalEnabled: PropTypes.bool,

  /**
   * Reference to the modal.
   */
  modalRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({current: PropTypes.any})]),

  /**
   * The application name or identifier..
   */
  app: PropTypes.string,
};

export default SearchSuggestionList;
